import React, { useEffect, useRef, useState, } from 'react';
import { BorderRadiusTokens, ColorTokens, DocumentPickerState, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, } from '@voltmoney/schema';
import Stack from '../stack/Stack';
import { Typography } from '../typography/Typography';
import { Icon } from '../icon/Icon';
import { Space } from '../space/Space';
import { ActivityIndicator, FlatList, Modal, Platform, StyleSheet, TouchableOpacity, View, } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { camera } from './camera.native';
const DocumentPicker = ({ titleLabel = '', ctaLabel = 'Upload', state, id, filSizeLimitInMB = 5, fileFormatSupported = [
    '.png',
    '.jpg',
    '.jpeg',
    '.pdf',
], action, triggerAction, }) => {
    var data = [
        { label: 'Camera', value: '1' },
        { label: 'Gallery', value: '2' },
        { label: 'File', value: '3' },
    ];
    const DropdownButton = useRef(undefined);
    const [selectFile, setSelected] = useState(null);
    const [visible, setVisible] = useState(false);
    const [dropdownTop, setDropdownTop] = useState(0);
    const [dropdownLeft, setDropdownLeft] = useState(0);
    const [dropdownWith, setDropdownWidth] = useState(0);
    const theme = ThemeProvider.getTheme();
    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);
    const handleAction = async () => {
        /** convert bytes to MB **/
        const bytesToMB = (bytes) => {
            return bytes / 1024 / 1024;
        };
        // const bytesToKB = (bytes) => {
        // 	return bytes / 1024 ;
        // };
        /*** Getting file size in MB ***/
        const size = Platform.OS === 'web'
            ? (selectFile.length * 3) / 4 / 1024 / 1024
            : bytesToMB(selectFile.size);
        if (size > filSizeLimitInMB) {
            alert(`Please upload file less than ${filSizeLimitInMB} 𝐌𝐁 and your file size is ${size.toFixed(2)} 𝐌𝐁`);
        }
        if (selectFile &&
            //  &&
            //  size < filSizeLimitInMB
            triggerAction &&
            action) {
            await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: selectFile,
                },
            });
        }
    };
    useEffect(() => {
        console.warn("TEST ID RECEIVED SAGAR", id);
    }, []);
    const handleFileSelected = (e) => {
        let file = e.target.files[0];
        setSelected(file);
    };
    useEffect(() => {
        if (selectFile) {
            handleAction();
        }
    }, [selectFile]);
    const colorMapping = theme.colors;
    const fontFamilyMapping = theme.fontFamily;
    const fontSizeMapping = theme.fontSize;
    const borderRadiusMapping = theme.borderRadius;
    const styles = StyleSheet.create({
        inputContainer: {
            width: 130,
            flexDirection: 'row',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR5],
            borderColor: colorMapping[ColorTokens.Grey_Smoke],
            borderWidth: 1,
            paddingVertical: 12,
            paddingHorizontal: 16,
            zIndex: 1,
        },
        inputContainerSuccess: {
            width: 130,
            flexDirection: 'row',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR5],
            borderColor: colorMapping[ColorTokens.Primary_100],
            borderWidth: 1,
            paddingVertical: 12,
            paddingHorizontal: 16,
            zIndex: 1,
        },
        buttonTextUnselected: {
            fontFamily: fontFamilyMapping[FontFamilyTokens.Inter],
            color: colorMapping[ColorTokens.Grey_Smoke],
            lineHeight: 24,
            fontSize: fontSizeMapping[FontSizeTokens.MD],
            fontWeight: '400',
        },
        buttonTextSelected: {
            fontFamily: fontFamilyMapping[FontFamilyTokens.Inter],
            color: colorMapping[ColorTokens.Grey_Night],
            lineHeight: 24,
            fontSize: fontSizeMapping[FontSizeTokens.XL],
            fontWeight: '400',
        },
        icon: {
            marginRight: 10,
        },
        dropdown: {
            backgroundColor: colorMapping[ColorTokens.White],
            shadowColor: colorMapping[ColorTokens.Grey_Smoke],
            borderColor: colorMapping[ColorTokens.Grey_Milk],
            borderWidth: 1,
            width: '100%',
            shadowOpacity: 0.1,
            shadowRadius: 4,
            position: 'absolute',
            bottom: 1,
        },
        overlay: {
            width: '100%',
            height: '100%',
        },
        item: {
            paddingHorizontal: 12,
            paddingVertical: 12,
            borderBottomWidth: 1,
            borderBottomColor: colorMapping[ColorTokens.Grey_Milk],
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        iconContainer: {
            position: 'relative',
            top: 5,
        },
    });
    const toggleDropdown = () => {
        visible ? setVisible(false) : openDropdown();
    };
    const openDropdown = () => {
        DropdownButton.current.measure((_fx, _fy, _w, h, _px, py) => {
            setDropdownTop(py + h + 5);
            setDropdownLeft(_px);
            setDropdownWidth(_w - 5);
        });
        setVisible(true);
    };
    const onItemPress = async (item) => {
        setVisible(false);
        if (Platform.OS === 'web') {
            hiddenFileInput.current.click();
        }
        else {
            sleep(500).then(() => {
                camera(item).then((res) => {
                    console.log('Item received is ', res);
                    setSelected(res);
                });
            });
        }
    };
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const renderItem = ({ item, }) => (React.createElement(TouchableOpacity, { style: {
            alignItems: 'center',
            justifyContent: 'center',
        }, onPress: () => onItemPress(item) },
        React.createElement(View, { style: styles.item },
            React.createElement(Typography, { label: item.label, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.MD, fontWeight: '400', fontFamily: FontFamilyTokens.Inter }))));
    const renderDropdown = () => {
        return (React.createElement(Modal, { visible: visible, transparent: true, animationType: 'slide' },
            React.createElement(TouchableOpacity, { style: styles.overlay, onPress: () => setVisible(false) },
                React.createElement(View, { style: [styles.dropdown] },
                    React.createElement(FlatList, { data: data, renderItem: renderItem, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                                backgroundColor: 'grey',
                                height: 0.5,
                            } })), keyExtractor: (item, index) => index.toString() })))));
    };
    return (React.createElement(Stack, { type: StackType.row, justifyContent: StackJustifyContent.spaceBetween, alignItems: StackAlignItems.center },
        React.createElement(Stack, { type: StackType.row, justifyContent: StackJustifyContent.flexStart, alignItems: StackAlignItems.center },
            React.createElement(Typography, { label: titleLabel, color: ColorTokens.Grey_Night, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24 }),
            (state === DocumentPickerState.SUCCESS ||
                state === DocumentPickerState.LOADING) && (React.createElement(Space, { size: SizeTypeTokens.MD })),
            state === DocumentPickerState.SUCCESS && (React.createElement(Icon, { name: IconTokens.Success, size: IconSizeTokens.LG })),
            state === DocumentPickerState.LOADING && (React.createElement(ActivityIndicator, { size: 24, color: theme.colors[ColorTokens.Primary_100] }))),
        Platform.OS === 'web' && (React.createElement("input", { ref: hiddenFileInput, type: 'file', id: 'file', accept: fileFormatSupported.join(','), onChange: handleFileSelected, style: { display: 'none' } })),
        React.createElement(TouchableOpacity, { ref: DropdownButton, testID: id, style: state === DocumentPickerState.SUCCESS
                ? styles.inputContainerSuccess
                : styles.inputContainer, onPress: () => Platform.OS === 'web'
                ? onItemPress({ label: '', value: '' })
                : toggleDropdown() },
            React.createElement(View, { testID: id },
                React.createElement(Typography, { label: state === DocumentPickerState.SUCCESS
                        ? 'Edit'
                        : 'Upload', fontSize: FontSizeTokens.MD, color: state === DocumentPickerState.SUCCESS
                        ? ColorTokens.Primary_100
                        : ColorTokens.Grey_Night, lineHeight: 24, fontWeight: '400', fontFamily: FontFamilyTokens.Inter })),
            visible && renderDropdown())));
};
export default React.memo(DocumentPicker);
export { DocumentPicker };
